import { makeStyles } from '@material-ui/core';
import { ISpcTheme } from '../../../../../../../common/theme/ISpcTheme';

export type FinanceDepositClasses = 'price' | 'label';

const financeDepositStyles = makeStyles<ISpcTheme>(
  ({ palette, typography, breakpoints }) => ({
    price: {
      color: palette.text.secondary,
      fontFamily: typography.fontFamily2,
      fontSize: typography.fontLG,
      lineHeight: '24px',
      margin: 0,

      [breakpoints.down('xs')]: {
        fontSize: typography.fontMD,
      },
    },
  }),
  { name: 'Customise_FinanceDeposit' },
);

export default financeDepositStyles;
